export enum TenantIngestionPriorityType {
    Normal = 'Normal',
    High = 'High'
}
